const GraphQLMutation = require('app/graphql/Mutation');

class Form {
    defaultOptions() {
        return {
            '$form': $('<form/>'),
            'mutationType': null,
            'variables': null,
            'fields': [],
            'before':  null,//function(form){},
            'success':  null,//function(data){},
            'error': null,//function(message,data){},
            'after': null,//function(form){}
        };
    }

    constructor(options) {
        this.settings = $.extend(this.defaultOptions(), options);

        this.$form = this.settings.$form;
        if(this.$form.length <= 0){
            window.notify("Can't find container view with selector " + this.settings.selector,'danger');
        }

        this.onChange = this.onChange.bind(this);
        this.onSubmit = this.onSubmit.bind(this);

        this.initialize();
    }

    initialize() {
        var self = this;
        this.$form.on('submit',this.onSubmit);

        this.$form.on('keyup change paste', 'input, select, textarea',this.onChange);
    }

    isValid(){
        var formObject = this.$form[0];
        var validity = formObject.checkValidity();

        this.$form.addClass('was-validated');

        if(validity === false){
            return false;
        }
        return true;
    }

    onSubmit(event){
        var self = this;
        event.stopPropagation();
        event.preventDefault();

        $('.input-error-container',this.$form).html('').hide();

        if(!this.isValid()){
            //@todo mb notify form is not valid
            return;
        }
        this.onBeforeSubmit();
    }

    onBeforeSubmit(){
        if(this.settings.before){
            this.settings.before(this);
        }
        return this.doSubmit();
    }

    getFields(){
        return [
            'success',
            'message',
            'errors { key, value }',
        ];
    }

    getVariables(){
        return {};
    }

    getData(){
        return new FormData(this.$form[0]);
    }

    doSubmit(){
        var self = this;


        let fields = this.getFields();

        let variables = this.getVariables();

        let data = this.getData();

        let mutation = new GraphQLMutation({
            //Mutation parameters
            'mutationType': this.settings.mutationType,
            'fields': fields,
            'variables': variables,//format: {NAME:{'type':TYPE, 'value': VALUE}}
            'data': data,

            //callbacks
            'before': function(){
            },
            'success': function(data){
                self.onSuccess(data);
            },
            'error': function(message, xhr){
                self.onError(message,xhr);
            },
            'after': function(){
                //do nothing
            }
        });
        mutation.execute();
    }

    onChange(event){
        this.$form.removeClass('was-validated');

        //reset customValidity message in order to be able to call isValid again
        $('input,textarea,select',this.$form).each(function(){
            let $element = $(this);
            $element[0].setCustomValidity('');
        });
    }

    onSuccess(data){
        this.$form.removeClass('was-validated');
        if(this.settings.success){
            return this.settings.success(data);
        }
        window.notify(data.message,"success");
    }

    onDOMReady(){
        
    }

    onError(message,data){
        if(this.settings.error){
            return this.settings.error(message,data);
        }
        window.notify(message,'error');
        
        let errors = data.errors;
        if(errors && errors.length > 0){
            let keys = Object.keys(errors);
            for(var i in errors){
                var error = errors[i];
                let inputName = error.key;
                let errorMessage = error.value;
                let $input= $('*[name="'+inputName+'"]',this.$form);
                if($input.length > 0){
                    let input = $input[0];

                    $input.attr('title',errorMessage);
                    input.setCustomValidity(errorMessage);
                    input.reportValidity();
                    $input.on('change',function(){
                        $input.removeAttr('title');
                        input.setCustomValidity('');
                    })
                }
            }
        }
    }

    onAfter(){
        if(this.settings.after){
            this.settings.after(this);
        }
    }

}

module.exports = Form;

